export default {"src":"/_next/static/media/fire-smoke-detection.3df071ad.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};